import CarouselWrapper from './CarouselWrapper';
import { getLoader } from './getListing';

const Loader = ({ title = '', onChangeMood = undefined, length = 4 }) => {
    return (
        <CarouselWrapper title={title} onChangeMood={onChangeMood} slidesPerView={length}>
            {getLoader(length)}
        </CarouselWrapper>
    );
};

export default Loader;
